import React, { useEffect, useState } from "react";
import LcIconLink from "../../Generic/LcIconLink";
import { Editor, EditorState, RichUtils, ContentState, convertFromHTML, DraftHandleValue } from "draft-js";
import "draft-js/dist/Draft.css";
import "./index.css";
import { SolicitationComment } from "../../../models/SolicitationComment";
import { useSelector } from "react-redux";
import { UserState } from "../../../store/reducers/userReducer";
import { RootState } from "../../../store/index";
import { MenuState } from "../../../store/reducers/menuReducer";
import Modal from "../../Dialog/Modal";
import { CircularProgress } from "@material-ui/core";
import EmailTemplateService from "../../../services/EmailTemplateService/EmailTemplateService";
import SolicitationCommentService from "../../../services/SolicitationCommentService/SolicitationCommentService";
import AlertNotification, { AlertColor } from "../../Dialog/AlertNotification";
import TextTools from "../../../services/TextTools/TextTools";
import HeyHoUserService from "../../../services/HeyHoUserService/HeyHoUserService";
import HHRichTextBoxDraftAttendant from "../HHRichTextBoxDraftAttendant";

interface Props {
    solicitation: any,
    attendant?: boolean,
    commentsLength: number,
    handleOpenAddAttachment: Function,
    files: any[],
    handleFiles: Function,
    removeFiles?: Function,
    handleSaveComment: Function,
    emailTemplates: any[],
    attendantType?: boolean
    setOpen?: Function
    tab?: number
    comments?: any[]
}

const CommentTextBoxDraftAttendant: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);

    const util = new TextTools();
    const emailTemplateService = new EmailTemplateService(props);
    const solicitationCommentService = new SolicitationCommentService(props);
    const heyHoUserService = new HeyHoUserService(props);

    const [editorState, setEditorState] = useState<string>("");
    const [showToolBar, setShowToolBar] = useState<boolean>();
    const [commentType, setCommentType] = useState<number>((props.attendant) ? 0 : 1);
    const [emailTemplateSelected, setEmailTemplateSelected] = useState<any>(undefined);
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [commentTemplateSelected, setCommentTemplateSelected] = useState<any>(undefined);
    const [destinatarios, setDestinatarios] = useState<any[]>([]);
    const [newDestinatarios, setNewDestinatarios] = useState<Array<string>>([]);
    const [newDestinatariosMention, setNewDestinatariosMention] = useState<Array<any>>([]);
    const [newDestinatario, setNewDestinatario] = useState<string>("");
    const [openConfirmEmail, setOpenConfirmEmail] = useState<boolean>(false);
    const [loadingAdd, setloadingAdd] = useState<boolean>(false);
    const [userMention, setUserMention] = useState<any>("");
    const [users, setUsers] = useState<any>([]);
    const [userMentionSelected, setUserMentionSelected] = useState<any>([]);
    const [userMentionRemoved, setUserMentionRemoved] = useState<string>("");
    const [detailing = "", setDetailing] = useState<string>("");

    useEffect(() => {
        setCommentTemplateSelected(undefined);
        setMessage("");
        setSeverity("info");
        setOpenNotificacao(false);
    }, []);

    useEffect(() => {
        if (props.setOpen) props.setOpen(showToolBar)
    }, [showToolBar])

    const handleClick = (editorStateText: any) => {
        let textoHtml = "";
        let type = "normal";

        // const stringLimpa = util.cleanAllTags(editorStateText).trim();
        let text = JSON.stringify(editorStateText.trim());
        text = text.replaceAll("\\n", "<br/>")
        const stringLimpa = JSON.parse(text);

        if (props.files.length > 0) {
            type = "anexo";
        }

        if (type === "normal") {
            textoHtml = stringLimpa;
        }
        else if (type === "anexo" && props.files.length > 0) {
            textoHtml = stringLimpa;
            // textoHtml = "Envio de anexo(s) de arquivo(s). Nome(s) do(s) arquivo(s):"

            props.files.map((file: any) => {
                // textoHtml += "\n\nEnvio de anexo(s) de arquivo(s). Nome(s) do(s) arquivo(s): " + file.name + ";"
                textoHtml += "\n\nEnvio de anexo(s) de arquivo(s). Nome(s) do(s) arquivo(s): " + TextTools.treatFile(file) + ";"
            })
        }

        // if(newDestinatariosMantion.length > 0) {
        //     setNewDestinatarios(
        //         newDestinatariosMantion.map(mantionEmail => {
        //             return mantionEmail.nickName;
        //         })
        //     )
        // }

        // componente dos comentarios tira o style salvo nos modelos de emails, adiciona de novo
        if (commentTemplateSelected && commentTemplateSelected.text.includes("</style>") && !textoHtml.includes("</style>")) {
            let style = commentTemplateSelected.text.split("</style>");
            style = style[0] + "</style>";
            textoHtml = style + textoHtml;
        }

        if (stringLimpa !== "" || props.files.length > 0) {
            let comment: SolicitationComment = {
                id: 0,
                idSolicitation: props.solicitation.id,
                commentDate: new Date(),
                commentType: (commentTemplateSelected) ? 3 : commentType,
                idUser: user.id,
                userName: user.name,
                text: textoHtml,
                disabled: false,
                externalEmails: newDestinatarios,
                cryptTag: window.location.pathname === "/" ? "Solicitante" : "Atendente",
                templateId: (commentTemplateSelected) ? commentTemplateSelected.id : 0,
            };

            props.handleSaveComment(comment);
        }
    }

    const handleOpenAddAttachment = () => {
        props.handleOpenAddAttachment();
    }

    const handleRemoveFiles = (files) => {
        props.removeFiles && props.removeFiles(files);
    }

    useEffect(() => {
        if (emailTemplateSelected) {
            const teste = EditorState.createWithContent(
                ContentState.createFromBlockArray(
                    convertFromHTML(emailTemplateSelected.text))
            );

            setEditorState(teste);
        }
    }, [emailTemplateSelected])

    const handleFiles = (files: Blob[], event?: any,): DraftHandleValue => {
        if (files) {
            props.handleFiles(files)
            return "handled";
        }
        else {
            return "not-handled";
        }
    }

    const getWidthObject = () => {
        if (!props.attendant) {
            return "35rem"; // Tamanho do sidemodal
        }
        if (showToolBar && (users.length > 0 || newDestinatariosMention.length > 0)) {
            if (!menu.toggle)
                return "calc(100% - 260px)";
            else
                return "calc(100% - 83px)";
        }
        if (!menu.toggle)
            return "calc(100% - 180px)";

        return "100%";
    }

    useEffect(() => {
        if (commentTemplateSelected) {
            getDestinatarios();
        }
    }, [commentTemplateSelected]);

    const getDestinatarios = async () => {
        setDestinatarios([]);
        setNewDestinatarios([]);

        try {
            const response = await emailTemplateService.getUserCommunicationTemplate(commentTemplateSelected.id);
            setDestinatarios(response.data.sort((a, b) => (a.userName > b.userName ? 1 : -1)));
        }
        catch (error) {
            debugger;
        }
    }

    const addNewDestinatario = async () => {
        if (newDestinatario !== "") {
            setloadingAdd(true);

            try {
                const response = await solicitationCommentService.VerifyDomainEmails(props.solicitation.id, newDestinatario);
                const emailValid: boolean = response.data[0].result;

                if (emailValid === true) {
                    confirmExistEmail();
                    setNewDestinatario("");
                }
                else {
                    setOpenConfirmEmail(true);
                }
            }
            catch (error) {
                confirmExistEmail();
                debugger;
            }

            setloadingAdd(false);
        }
    }

    const confirmExistEmail = () => {
        const validarEmail = validateEmail(newDestinatario);

        if (!validarEmail) {
            notificationValidation("E-mail inválido", "warning");
        }
        else {
            const emailExiste = newDestinatarios.find(x => x === newDestinatario);

            if (emailExiste) {
                notificationValidation("E-mail já adicionado", "warning");
            }
            else {
                setNewDestinatarios([...newDestinatarios, newDestinatario]);
            }
        }
    }

    const addEmailExterno = () => {
        confirmExistEmail();
        setOpenConfirmEmail(false);
    }

    const removeNewDestinatario = (newDestinatario_: string | any, type?: string) => {
        if (type === "mention") {
            const newDestinatarios_ = newDestinatariosMention.filter(x => {
                return x.id !== newDestinatario_.id
            });

            setNewDestinatariosMention(newDestinatarios_);
            setUserMentionSelected(newDestinatarios_);
            setUserMentionRemoved(newDestinatario_);

            setNewDestinatarios(newDestinatarios_.map(email => {
                return email.nickName;
            }));
        }
        else {
            const newDestinatarios_ = newDestinatarios.filter(x => x !== newDestinatario_);
            setNewDestinatarios(newDestinatarios_);
        }
    }

    const validateEmail = (email: string) => {
        var emailRegex = /^[-!#$%&"*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&"*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

        if (!email) return false;
        if (email.length > 254) return false;

        var valid = emailRegex.test(email);
        if (!valid) return false;

        var parts = email.split("@");
        if (parts[0].length > 64) return false;

        var domainParts = parts[1].split(".");
        if (domainParts.some(function (part) { return part.length > 63; })) return false;

        return true;
    }

    useEffect(() => {
        if (!openConfirmEmail) {
            setNewDestinatario("");
        }
    }, [openConfirmEmail]);

    const notificationValidation = (mensagem: string, tipo: AlertColor) => {
        setMessage(mensagem);
        setSeverity(tipo);
        setOpenNotificacao(true);
    }

    useEffect(() => {
        if (userMention.length > 3) {
            getMentionUser();
        }
        else {
            setUsers([]);
        }
    }, [userMention])

    const getMentionUser = async () => {
        var reduced: any = [];

        try {
            let responseMention = await heyHoUserService.GetUserByNickName(userMention, props.solicitation.idCustomer);
            responseMention.data.forEach((item) => {
                var duplicated = reduced.findIndex(redItem => {
                    return item.id == redItem.id;
                }) > -1;

                if (!duplicated) {
                    reduced.push(item);
                }
            });

            const filteredUsers = reduced.filter(user => !newDestinatariosMention.some(existingUser => existingUser.id === user.id));

            setUsers(filteredUsers)
        }
        catch (error) {
            debugger
            console.debug(error)
        }
    }

    const handleSelectUserMention = (id: number) => {
        let userSelect = users.filter(i => i.id === id);
        setUserMentionSelected(userSelect);
        setNewDestinatariosMention(arr => [...arr, ...userSelect]);
        setNewDestinatarios(arr => [...arr, userSelect[0].nickName]);
        setUsers([]);
    }

    return (
        <>
            <div style={{ marginTop: (props.attendant) ? "100px" : (props.files.length > 2) ? "120px" : "" }}>
                {
                    <div className={"menuActions"}
                        style={{
                            marginLeft: "-30px",
                            right: "",
                            width: getWidthObject(),
                            flexDirection: ((showToolBar === true && (users.length > 0 || newDestinatariosMention.length > 0)) ? 'row' : 'column'),
                            transition: 'width 0.5s ease'
                        }}>
                        <HHRichTextBoxDraftAttendant
                            onChange={setEditorState}
                            value={detailing}
                            setCommentType={e => setCommentType(parseInt(e))}
                            openAttachment={handleOpenAddAttachment}
                            handleFiles={handleFiles}
                            placeholder={"Escreva sua mensagem"}
                            handleClick={handleClick}
                            comment={true}
                            setToolbar={setShowToolBar}
                            emailTemplates={props.emailTemplates ?? []}
                            setCommentTemplateSelected={setCommentTemplateSelected}
                            files={props.files ?? []}
                            removeFiles={handleRemoveFiles}
                            userMention={setUserMention}
                            selectedMentions={userMentionSelected}
                            removedMention={userMentionRemoved}
                            mentions={newDestinatariosMention}
                            removeMention={removeNewDestinatario}
                            refreshRemoved={setUserMentionRemoved}
                            solicitation={props.solicitation}
                            comments={props.comments}
                        />
                        {
                            showToolBar === true && commentTemplateSelected &&
                            <div className={"divOrderAddDestinatarios"} style={{ marginTop: "10px" }}>
                                <span style={{ marginRight: "10px", fontSize: "15px" }} children={"Incluir destinatário:"} />
                                <div className={"input-12"} style={{ marginRight: "10px" }}>
                                    <input
                                        type={"text"}
                                        onChange={(e) => setNewDestinatario(e.target.value)}
                                        value={newDestinatario}
                                        autoComplete={"false"}
                                        style={{
                                            padding: "10px",
                                            height: "40px",
                                            borderRadius: "4px",
                                            border: "1px solid grey",
                                            width: "400px",
                                            fontSize: "14px",
                                            fontFamily: "Inter"
                                        }}
                                    />
                                </div>
                                <button className={"lc-button small bg-info"} style={{ height: "40px", marginRight: "20px" }} children={"Adicionar Destinatário"} onClick={() => addNewDestinatario()} />
                                {
                                    loadingAdd && <CircularProgress />
                                }
                            </div>
                        }
                        {
                            showToolBar === true && commentTemplateSelected &&
                            <div className={"divOrderDestinatarios"}>
                                <span style={{ marginBottom: "5px", fontSize: "15px", alignItems: "center" }}> Destinatários: </span>
                                <div className={"divOrderDestinatariosList"}>
                                    {
                                        destinatarios.length === 0 && newDestinatarios.length === 0
                                            ? <span style={{ fontSize: "14px", margin: "5px" }}> Nenhum cadastro de destinatário para esse modelo de email </span>
                                            : <>
                                                {
                                                    destinatarios.map(destinatario => (
                                                        <span className={"destinatarioSpan"} style={{ fontSize: "14px", margin: "5px" }}>{destinatario.userName}</span>
                                                    ))
                                                }
                                                {
                                                    newDestinatarios.map(newDestinatario => (
                                                        <div className={"divOrderNewDestinatarios"}>
                                                            <span className={"destinatarioSpan"} style={{ fontSize: "14px", margin: "5px" }}>{newDestinatario}</span>
                                                            <LcIconLink icon={"ppi ppi-trash"} onClick={() => removeNewDestinatario(newDestinatario)} size={"small"} />
                                                        </div>
                                                    ))
                                                }
                                            </>
                                    }
                                </div>
                            </div>
                        }
                        {
                            showToolBar === true && (users.length > 0 || newDestinatariosMention.length > 0) && props.attendant &&
                            <>
                                <div>
                                    <div
                                        style={{ maxHeight: (users.length > 0 || newDestinatariosMention.length > 0) ? "200px" : "0px", width: '30vw', alignItems: (users.length == 0 && newDestinatariosMention.length > 0) ? 'center' : '' }}
                                        className={"divOrderDestinatariosMantion"
                                        }>
                                        <span style={{ textAlign: 'center', marginTop: '60px', marginBottom: "10px", fontSize: "15px", fontWeight: '600' }}> Destinatários: </span>
                                        <div style={{ maxHeight: '125px', display: 'flex', flexDirection: 'row' }}>
                                            {
                                                users.length > 0 &&
                                                <div className={"listuser"} style={{
                                                    maxHeight: (newDestinatariosMention.length > 0) ? '50%' : '100%',
                                                    minHeight: (newDestinatariosMention.length > 0 && users.length > 0) ? '25%' : '',
                                                    width: (newDestinatariosMention.length > 0 && users.length > 0) ? '50%' : '',
                                                    borderRight: (newDestinatariosMention.length > 0) ? '5px solid transparent' : ''
                                                }}>
                                                    {
                                                        users.map((user: { id: number; name: string }) => {
                                                            return (
                                                                <p key={user.id} onClick={() => handleSelectUserMention(user.id)}>
                                                                    {user.name}
                                                                </p>
                                                            )
                                                        })
                                                    }

                                                </div>
                                            }
                                            {
                                                newDestinatariosMention.length > 0 &&
                                                <div style={{ width: (users.length > 0) ? '50%' : '', minHeight: (newDestinatariosMention.length > 0) ? '25%' : '' }} className={"divOrderDestinatariosList"}>
                                                    {
                                                        <>
                                                            {
                                                                newDestinatariosMention.map(newDestinatario => (
                                                                    <div key={newDestinatario.id} className={"divOrderNewDestinatarios"}>
                                                                        <span className={"destinatarioSpan"} style={{ fontSize: "14px", margin: "5px" }}>{newDestinatario.nickName}</span>
                                                                        <LcIconLink icon={"ppi ppi-trash"} onClick={() => removeNewDestinatario(newDestinatario, "mention")} size={"small"} />
                                                                    </div>
                                                                ))
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                }
            </div>

            <Modal title={"Adicionar e-mail"} visible={openConfirmEmail} close={() => setOpenConfirmEmail(false)}>
                <span>{"O e-mail inserido não pertence aos domínios deste cliente, deseja realmente adicionar?"}</span>
                <div className={"divOrderButtonsEmails"}>
                    <button className={"lc-button bg-info"} onClick={() => addEmailExterno()}> Confirmar </button>
                    <button className={"lc-button bg-info"} onClick={() => setOpenConfirmEmail(false)}> Cancelar </button>
                </div>
            </Modal>

            <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={() => setOpenNotificacao(false)} />
        </>
    );
};

export default CommentTextBoxDraftAttendant;